import { render, staticRenderFns } from "./table4.vue?vue&type=template&id=6ca302a7&scoped=true&"
import script from "./table4.vue?vue&type=script&lang=js&"
export * from "./table4.vue?vue&type=script&lang=js&"
import style0 from "./table4.vue?vue&type=style&index=0&id=6ca302a7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca302a7",
  null
  
)

export default component.exports